import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ignacio/Documents/REPOSITORY/WEBSITES/Apex-Experience/apex-next/app/(booking)/BookingLayoutClient.tsx");
